import { footprintPrice } from "../../../components/store";
import { ShopifyShopSystemStrategy } from "./ShopifyShopSystemStrategy";

type ManagementClass = Element & {
  getSectionsToRender(): { id: string; section: string; selector: string }[];
  getSectionInnerHTML(html: any, selector: any): string;
};

export class ShopifyTestShopSystemStrategy extends ShopifyShopSystemStrategy {
  async loadingDone(): Promise<void> {}
  registerEventHandlers(): void {
    super.registerEventHandlers();
    const node = document.querySelector("cart-drawer");
    const observer = new MutationObserver((mutations, observer) => {
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
    });
    if (node) {
      observer.observe(node, {
        attributes: false,
        childList: true,
        subtree: false,
      });
    }

    window.addEventListener("cart-change", async (ev) => {
      const cart = await this.getCart();
      const offset = this.getOffsetItem(cart);
      if (offset && cart!.items.length === 1) {
        await this.toggleOffset(false, true);
      }
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
    });

    footprintPrice.subscribe(async (value) => {
      if (value == 0) return;
      const cart = await this.getCart();
      const offset = this.getOffsetItem(cart);
      if (!offset) return;
      // If our price already matches, nothing needs to happen.
      if (offset.price != Math.round(value * 100)) {
        // Refresh if this if the offset is the last item in the cart.
        await this.toggleOffset(false, cart!.items.length === 1);
        if (cart!.items.length > 1) await this.toggleOffset(true);
      }
    });
  }
  async refreshCart(): Promise<void> {}
  beginOffset() {}

  endOffset() {}

  bundledSections(): string[] {
    const cart = document.querySelector("cart-drawer") as ManagementClass;
    return cart.getSectionsToRender().map((section: any) => section.id);
  }

  bundledSectionsCallback(sections: any) {
    const cart = document.querySelector("cart-drawer") as ManagementClass;
    for (const section in sections) {
      try {
        const result = cart.getSectionInnerHTML(sections[section], section);
        const elementToReplace = document.querySelector(section);
        if (elementToReplace) elementToReplace.innerHTML = result;
      } catch (e) {}
    }
  }
}
